/// <reference path="DOMAttached.js" />

class IFrame extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.loadReady();
		document.loadReady = this.loadReady.bind(this);
	}

	loadReady() {
		this.iframeDoc = this.el.contentWindow || this.el.contentDocument;
		if (this.iframeDoc.document) {
			this.iframeDoc = this.iframeDoc.document;
			this.el.style.height = this.iframeDoc.body.scrollHeight + "px";
		}
	}
}
